/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-23 16:13:06
 * @LastEditors: bbq
 * @LastEditTime: 2020-09-01 20:31:12
 */

/**
 *  enterkey使用
 * @desc 现在attrCode 名称中有 xxx.xx 的情况导致 查询dom 元素时 找不到的情况
 * @resolve 如果attrCode中存在.  xxx.xx -> xxx_xx
 * @param name
 * @return name
 */
export function processCodeClassName(name) {
    return name.indexOf('.') === -1
        ? name
        : name.replace(/\./g, '_');
}

//在form组件的state中获取元素是否可见 enterkey使用
export function getVisibleStatusInStates({ visibleState, moduleId, attrCode }) {
    if (visibleState[moduleId]) {
        return visibleState[moduleId][attrCode] === false;
    } else {
        return visibleState[attrCode] === false;
    }
}

//  enterkey使用
export function itemIsDisable(disableState, item) {
    let { attrcode } = item;

    if (disableState[attrcode] !== true) return false;

    return disableState[attrcode] === true || item.disabled === true;
}

//  enterkey使用
export function itemIsVisible(visibleState, item, moduleId) {
    let { attrcode } = item;
    return getVisibleStatusInStates({ visibleState, moduleId, attrCode: attrcode }) || item.visible === false;
}

/**
 * 给编辑前使用
 * @param fields {array} 所有字段
 * @param disableFields {object} 不可聚焦啊字段
 * @param currentItem {object} 当前字段
 * @return {object}
 */
export function findFocusItem(fields, disableFields, currentItem) {
    let next = '',
        prev = '';

    fields.forEach((item, index) => {
        if (item == currentItem.attrcode) {
            let nextField = fields[index + 1];
            let prevField = fields[index - 1];
            next = disableFields[nextField] === true
                ? findNextFocusItem(fields.slice(index + 1), disableFields)
                : nextField;

            prev = disableFields[prevField] === true
                ? findPrevFocusItem(fields.slice(0, index - 1), disableFields)
                : prevField;
        }
    });

    return {
        next,
        prev,
    };
}

function findNextFocusItem(fields, disableFields) {
    return fields.find(item => {
        return disableFields[item] !== true;
    });
}

function findPrevFocusItem(fields, disableFields) {
    return fields.reverse().find(item => {
        return disableFields[item] !== true;
    });
}

export function getFxExpression(VALUE, context = {}) {
    let reslut = JSON.parse(JSON.stringify(VALUE));
    let mainOrgVal = context.pk_org || '';
    let fxObj = {
        '#mainorg#': {
            // 默认主组织
            display: mainOrgVal ? context.org_Name : '',
            value: mainOrgVal,
        },
        '#DefaultCostRegion#': {
            // 默认财务成本域
            display: context.defaultCostRegionName || '',
            value: context.defaultCostRegionPk || '',
        },
        '#DefaultCreditCtlRegion#': {
            //默认信用域
            display: context.defaultCreditCtlRegionName || '',
            value: context.defaultCreditCtlRegionPk || '',
        },
        '#operator#': {
            //当前操作员
            display: context.userName || '',
            value: context.userId || '',
        },
        '#currentgroup#': {
            //当前集团
            display: context.groupName || '',
            value: context.groupId || '',
        },
        '#DefaultLiactCostrgFunction#': {
            //默认利润中心成本域
            display: context.defaultCenterContentName || '',
            value: context.defaultCenterContentPK || '',
        },
        "#DefaultCostrgOrLiactCostrgFunc#": {
            //默认成本域
            display: context.defaultCostRegionName || context.defaultCenterContentName || '',
            value: context.defaultCostRegionPk || context.defaultCenterContentPK || '',
        },
        "#busioperator#": {
            //当前人员
            display: context.defaultPsndocName || '',
            value: context.defaultPsndocPK || '',
        },
        "#rbacdept#": {
            //当前人员所属部门 
            display: context.defaultDeptName || '',
            value: context.defaultDeptPK || '',
        },
        "#globeorg#": {
            //全局  
            display: context.globeName || '',
            value: context.globePK || '',
        },
        "#currperiod#": {
            //当前计划周期 
            display: context.currperiodName || '',
            value: context.currperiodPK || '',
        },
        "#mainaccperiod#": {
            //默认会计期间 
            display: context.mainacceperiodName || '',
            value: context.mainAcceperiodPK || '',
        },
        "#currentaccperiod#": {
            //当前期间 
            display: context.currentAccperiodName || '',
            value: context.currentAccperiodPk || '',
        },
        "#rbacdeptsubincluded#": {
            //用户主职部门及其下级  数组
            display: Array.isArray(context.defaultDeptsubincludedName) ? context.defaultDeptsubincludedName.join(',') : context.defaultDeptsubincludedName || '',
            value: Array.isArray(context.defaultDeptsubincludedPK) ? context.defaultDeptsubincludedPK.join(',') : context.defaultDeptsubincludedPK || '',
        },
        "#firstaccperiod#": {
            //第一个期间 
            display: context.fristAccperiodName || '',
            value: context.fristAccperiodPK || '',
        },
        "#accountingbook#": {
            //默认（总账）账簿 
            display: context.accountingBookName || '',
            value: context.accountingBookPk || '',
        },
    };

    if (Array.isArray(reslut)) {
        reslut.map(item => {
            if (item.value && item.value.indexOf('#') !== -1) {
                item = fxObj[item.value] || item;
            }
            return item;
        });
    } else {
        if (reslut.value && reslut.value.indexOf('#') !== -1) {
            reslut = fxObj[reslut.value] || reslut;
        }
    }
    return reslut;
}